<div class="row table-div">
  <div class="sub-title-class">
    <div class="headingTitle" id="packagingMatrics">
      <div>{{ reportResource.lblPackingMatrics }}</div>
    </div>
  </div>
  <div class="row table-div">
    <div class="page-break"></div>
    <div class="tableHeading">
      <div class="uniqTableSeq content-name-subtitle">
        Table #1: {{ reportResource.lblPackingMatrics }}
      </div>
    </div>
  </div>
  <br />
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <ng-container *ngIf="packagingMatrics?.componentItems?.length == 33">
            <th style="height: 0px; padding: 0px; border-left: 0px">
              <table style="background-color: white; height: 100%; width: 100%; border-left: 0px">
                <tr>
                  <td
                    style="-webkit-transform: rotate(180deg); white-space: nowrap; border-left: 0px"
                  >
                    &nbsp;
                  </td>
                </tr>
              </table>
            </th>
          </ng-container>
          <td>{{ reportResource.lblCriteria }}</td>
          <ng-container *ngIf="packagingMatrics?.componentItems?.length > 0">
            <td *ngFor="let item of packagingMatrics.componentItems[0]?.componentName?.split(';')">
              {{ item }}
            </td>
          </ng-container>
        </tr>
      </thead>

      <ng-container *ngIf="packagingMatrics?.componentItems?.length == 33; else elseBlock1">
        <tbody>
          <tr *ngFor="let p of packagingMatrics?.componentItems; let i = index">
            <ng-container *ngIf="packagingMatrics.isExport; else other_content_isExport">
              <td *ngIf="i == 0" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">
                        {{ reportResource.lblCircularEconomyMetrics }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td *ngIf="i == 1" rowspan="11" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">
                        {{ reportResource.lblGlobalPackagingMetric }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td *ngIf="i == 12" rowspan="10" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">
                        {{ reportResource.lblPackagingLevelMetric }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <ng-container *ngIf="i < 22">
                <ng-container *ngIf="i == 0; else other_check_impact">
                  <td style="text-align: left; height: 250px">
                    {{ packagingMatrics.componentItems[i]?.name }}
                  </td>
                  <td
                    *ngFor="
                      let value of packagingMatrics.componentItems[i]?.impactValues?.split(';')
                    "
                    style="text-align: left; height: 250px"
                  >
                    {{ value }}
                  </td>
                </ng-container>
                <ng-template #other_check_impact>
                  <td style="text-align: left">{{ packagingMatrics.componentItems[i]?.name }}</td>
                  <td
                    style="text-align: left"
                    *ngFor="
                      let value of packagingMatrics.componentItems[i]?.impactValues?.split(';')
                    "
                  >
                    {{ value }}
                  </td>
                </ng-template>
              </ng-container>
            </ng-container>
            <ng-template #other_content_isExport>
              <td *ngIf="i == 0" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">
                        {{ reportResource.lblCircularEconomyMetrics }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td *ngIf="i == 1" rowspan="11" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">
                        {{ reportResource.lblGlobalPackagingMetric }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td *ngIf="i == 12" rowspan="10" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">
                        {{ reportResource.lblPackagingLevelMetric }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td *ngIf="i == 22" rowspan="11" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">
                        {{ reportResource.lblEndofLifeBreakdown }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <ng-container *ngIf="i == 0; else other_check_impactsecond">
                <td style="text-align: left; height: 250px">
                  {{ packagingMatrics?.componentItems[i]?.name }}
                </td>
                <td
                  *ngFor="let value of packagingMatrics.componentItems[i]?.impactValues?.split(';')"
                >
                  {{ value }}
                </td>
              </ng-container>
              <ng-template #other_check_impactsecond>
                <td style="text-align: left">{{ packagingMatrics?.componentItems[i]?.name }}</td>
                <td
                  *ngFor="let value of packagingMatrics.componentItems[i]?.impactValues?.split(';')"
                >
                  {{ value }}
                </td>
              </ng-template>
            </ng-template>
          </tr>
        </tbody>
      </ng-container>

      <ng-template #elseBlock1>
        <ng-container *ngIf="packagingMatrics?.componentItems?.length > 0; else elseBlock2">
          <tbody>
            <ng-container *ngFor="let item of groupedData">
              <ng-container *ngIf="packagingMatrics.isExport; else other_groupedData_isExport">
                <ng-container *ngIf="item">
                  <tr>
                    <td
                      *ngIf="item[0] == '4'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblCircularEconomyMetrics }}
                    </td>
                    <td
                      *ngIf="item[0] == '1'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblGlobalPackagingMetric }}
                    </td>
                    <td
                      *ngIf="item[0] == '2'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblPackagingLevelMetric }}
                    </td>
                    <td
                      *ngIf="item[0] == '3'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblEndofLifeBreakdown }}
                    </td>
                  </tr>
                  <tr *ngFor="let categoryItems of item[1]">
                    <td>{{ categoryItems.name }}</td>
                    <td *ngFor="let p of categoryItems?.impactValues?.split(';')">{{ p }}</td>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-template #other_groupedData_isExport>
                <ng-container *ngIf="item">
                  <tr>
                    <td
                      *ngIf="item[0] == '4'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblCircularEconomyMetrics }}
                    </td>
                    <td
                      *ngIf="item[0] == '1'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblGlobalPackagingMetric }}
                    </td>
                    <td
                      *ngIf="item[0] == '2'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblPackagingLevelMetric }}
                    </td>
                    <td
                      *ngIf="item[0] == '3'"
                      class="groupTd"
                      [attr.colspan]="
                        packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                      "
                    >
                      {{ reportResource.lblEndofLifeBreakdown }}
                    </td>
                  </tr>
                  <tr *ngFor="let categoryItems of item[1]">
                    <td>{{ categoryItems.name }}</td>
                    <td *ngFor="let p of categoryItems?.impactValues?.split(';')">{{ p }}</td>
                  </tr>
                </ng-container>
              </ng-template>
            </ng-container>
          </tbody>
        </ng-container>

        <ng-template #elseBlock2>
          <tbody>
            <tr>
              <td
                [attr.colspan]="
                  packagingMatrics?.componentItems[0]?.componentName?.split(';')?.length + 1
                "
                class="lblNoData"
              >
                {{ reportResource.lblNoData }}
              </td>
            </tr>
          </tbody>
        </ng-template>
      </ng-template>
    </table>

    <div>
      <ng-container *ngIf="packagingMatrics.isExport">
        <div class="page-break"></div>
        <table class="table">
          <tbody *ngIf="packagingMatrics?.componentItems?.length == 33">
            <tr *ngFor="let data of packagingMatrics?.componentItems; let p = index">
              <td *ngIf="p == 22" rowspan="11" class="rotateClass">
                <table class="rotateTableClass">
                  <tr>
                    <td style="white-space: nowrap">
                      <div class="rotateDegree">{{ reportResource.lblEndofLifeBreakdown }}</div>
                    </td>
                  </tr>
                </table>
              </td>
              <ng-container *ngIf="p >= 22">
                <td style="text-align: left">
                  {{ packagingMatrics?.componentItems[p]?.name }}
                </td>
                <td
                  style="text-align: left"
                  *ngFor="
                    let value of packagingMatrics?.componentItems[p]?.impactValues?.split(';')
                  "
                >
                  {{ value }}
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>
</div>
